import React from 'react';
import type { OrganizationRole, SelectOption } from '../../types/roles';
import SelectDropdown from '~/ui/3dbiaUI/SelectDropdown';
import BiaSelect from '~/ui/3dbiaUI/BiaSelect/BiaSelect';

interface RolesProps {
  roles: OrganizationRole[];
  selectedRole: OrganizationRole | undefined;
  onRoleClick: (role: OrganizationRole) => void;
}

const Roles: React.FC<RolesProps> = ({ 
  roles, 
  selectedRole, 
  onRoleClick 
}) => {
  const rolesSelect: SelectOption[] = roles.map(role => ({
    id: role.role_id,
    name: role.role_name,
  }));

  return (
    <BiaSelect
      className={`large ${!roles.length ? 'disabled' : ''}`}
      labelClass='d-none'
      options={rolesSelect}
      value={selectedRole?.role_id}
      onChange={(roleId) => {
        console.log('Selected role ID:', roleId);
        onRoleClick(roles.find(role => role.role_id === roleId)!);
      }}
    />
  );
};

export default Roles;
